// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"267":"b3f54df5","453":"2239203b","537":"be8b8936"}[chunkId] + ".chunk.js";
};